<template>
  <crud-form
    v-model="payload"
    page-title="Adicionar pergunta"
    :request-class="requestClass"
    :total-group="3"
    navigate-back-route="contacard.faq.questions.list"
    navigate-page-after-save="contacard.faq.questions.list"
  >
    <template slot="group-1">
      <form-group title="Dados da pergunta">
        <v-row justify="start">
          <v-col cols="12">
            <input-radio
              id="input:isPreLogin"
              v-model="payload.isPreLogin"
              :options="preLoginOptions"
              label="Faq de pré-login"
              row
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              id="input:question"
              v-model="payload.question"
              :rules="[requiredRule]"
              label="Pergunta"
              outlined
              required
              rows="3"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              id="input:answer"
              v-model="payload.answer"
              :rules="[requiredRule]"
              label="Resposta"
              outlined
              rows="3"
            />
          </v-col>
        </v-row>
        <v-row :class="getId ? '' : 'justify-end'">
          <v-col
            v-if="getId"
            cols="6"
          >
            <input-text
              id="input:order"
              v-model="payload.order"
              label="Ordem"
              type="number"
              outlined
              required
            />
          </v-col>
          <v-col cols="6">
            <input-select
              id="input:categoryId"
              v-model.lazy="payload.categoryId"
              :items="categories"
              item-text="name"
              item-value="id"
              :rules="[requiredRule]"
              label="Categoria"
              :loading="loadingCategories"
              outlined
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from 'Arch/components/crud/CrudForm.vue';
import QuestionsRequest from 'Modules/contacard/faq/questions/QuestionsRequest';
import FormGroup from 'Arch/components/crud/components/FormGroup.vue';
import RulesMixin from 'Arch/mixins/RulesMixin';
import CategoriesRequest from 'Modules/contacard/faq/categories/CategoriesRequest';
import NotificationMixin from 'Arch/mixins/NotificationMixin';

export default {
  name: 'InformativesForm',
  components: {
    CrudForm,
    FormGroup,
  },
  mixins: [RulesMixin, NotificationMixin],
  data: () => ({
    requestClass: QuestionsRequest,
    payload: {
      id: null,
      question: '',
      answer: '',
      categoryId: null,
      order: '',
      isPreLogin: '',
    },
    loadingCategories: false,
    categories: [],
    preLoginOptions: [
      {
        label: 'Sim',
        value: true,
      },
      {
        label: 'Não',
        value: false,
        color: 'primary',
      },
    ],
  }),
  computed: {
    getId() {
      return this.$route.params.id;
    },
  },
  created() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.loadingCategories = true;
      CategoriesRequest.list()
        .then((response) => {
          const { data } = response;
          this.categories = data.data;
        })
        .finally(() => {
          this.loadingCategories = false;
        });
    },
  },
};
</script>
